import { Text } from "@chakra-ui/react";
import { useMemo } from "react";

export const ViewSectionQualifications = (props) => {
  const { profile } = props;
  const { qualifications } = profile;

  const decodeText = (input) => {
    const isServer = typeof window === "undefined";
    if (isServer) {
      return input;
    }
    const decodeElement = document.createElement("div");
    let text = input;

    if (text && typeof text === "string") {
      text = text.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
      text = text.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
      decodeElement.innerHTML = text;
      text = decodeElement.textContent;
      decodeElement.textContent = "";
    }

    return text;
  };

  return (
    <div className="relative flex flex-col p-[30px] gap-5">
      <Text textStyle="h3">Training and qualifications</Text>
      {qualifications?.map((area, idx) => (
        <p
          className="text-brand-text font-[400]"
          style={{ whiteSpace: "pre-line" }}
          key={idx}
        >
          {decodeText(area)}
        </p>
      ))}
    </div>
  );
};
